import { getMenuNodesByCategory } from "components/CC/Nodes/node-config";
import { BaseNodeProps } from "components/CC/Nodes/node-types.ts";
import { NodePopover } from "components/CC/Nodes/NodeBase/NodePopover.tsx";
import { NodeType } from "components/CC/types/enums.ts";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";

interface MethodsNodeProps extends BaseNodeProps {
    data: BaseNodeProps["data"] & {
        onSelectType?: (nodeType: NodeType) => void;
    };
}

export const MethodsNode = ({ data }: MethodsNodeProps) => {
    const { t } = usePaldockTranslation("components.connection-creator");

    const handleSelectType = (nodeType: NodeType) => {
        data.onSelectType?.(nodeType);
    };

    const menuConfig = getMenuNodesByCategory();

    // Show empty node with popover to select type
    return (
        <NodePopover>
            <NodePopover.Menu withSearch>
                {menuConfig.map(({ category, nodes }) => (
                    <NodePopover.MenuSection
                        key={category}
                        title={t(`enums.node_category.${category}`)}
                        category={category}
                    >
                        {nodes.map(({ type, entry }) => (
                            <NodePopover.MenuSectionItem
                                key={type}
                                title={t(entry.title)}
                                color={entry.color}
                                icon={entry.icon}
                                onClick={() => handleSelectType(type)}
                            />
                        ))}
                    </NodePopover.MenuSection>
                ))}
            </NodePopover.Menu>
        </NodePopover>
    );
};
